import { GroupCriterion } from './group-criterion'

export class Group {
    id!: string
    name!: string
    isActive!: boolean
    groupUsers: { groupId: string; userId: string; include: boolean; exclude: boolean }[] = []
    groupCriteria: GroupCriterion[] = []
}
